import React, { useState } from 'react';
import * as Styles from './CreateTicketStep1.style';
import { StepLabel } from 'components/step-label/StepLabel';
import RadioButton from 'components/radio-button/RadioButton';
import FormikErrorMessage from 'components/formik-error-message/FormikErrorMessage';
import { Icon } from 'semantic-ui-react';
import Input from 'components/input';
import { useMutation } from 'react-query';
import { SEARCH } from 'components/support/queries';
import { checkbox } from 'components/support/utils';
import { H5, H6 } from 'utils/resuable-css';
import axios from 'axios';
import { BASE_URL } from 'constants/env';
import { useTranslation } from 'react-i18next';

const CreateTicketStep1 = ({ formikProp, userData, setUserData }) => {
  const { t } = useTranslation();
  const { values, setFieldValue, handleBlur, errors, touched } = formikProp;
  const [searchResult, setSearchResult] = useState({});
  const { mutate: searhResult } = useMutation(SEARCH);

  const handleChangeSearch = async (text) => {
    setFieldValue('username', text);
    await searhResult(
      {
        searchResult: text,
      },
      {
        onSuccess: (e) => {
          setSearchResult(e);
        },
      },
    );
  };

  const callUserAPI = async (username) => {
    setFieldValue('username', username);
    const res = await axios.get(BASE_URL + `/admin/user/${username}`);
    setUserData(res.data);
    setSearchResult({});
  };

  return (
    <Styles.CreateTicketStep1SC>
      <StepLabel id="ST1" stepCount={'admin/tickets/create.step1_string1'}>
        {t('admin/tickets/create.step1_string2')}
      </StepLabel>
      <Styles.SearchUsername>
        <Styles.Search>
          <Input
            name={'username'}
            value={values['username']}
            onBlur={handleBlur}
            error={errors['username']}
            touched={touched['username']}
            placeholder={'admin/tickets/create.step1_string3'}
            onChange={(e) => handleChangeSearch(e.target.value)}
            onEnter={(e) => callUserAPI(values.username)}
            EndAdornment={() => (
              <span>
                <Icon name="search" />
              </span>
            )}
            styling={{ width: '38em' }}
          />
          {searchResult?.results_found === '1' && (
            <Styles.SearchContainer>
              {searchResult?.users?.results?.map((item, i) => (
                <div key={i} className="link" onClick={() => callUserAPI(item.record_id)}>
                  <Icon name="circle" />
                  <H6>{item.search_term_en}</H6>
                </div>
              ))}
            </Styles.SearchContainer>
          )}
        </Styles.Search>
        <Styles.SearchResult>
          {userData?.user !== undefined &&
            userData?.user?.map((user, i) => (
              <div key={i} className="userInfo">
                <H5 className="main-heading">{t('admin/tickets/create.step1_string5', { name: user?.username })}</H5>
                {user.email1 !== '' && (
                  <div className="email">
                    <Icon name="circle" />
                    <H6 className="email-address">{user.email1}</H6>
                  </div>
                )}
                {user.email2 !== '' && (
                  <div className="email">
                    <Icon name="circle" />
                    <H6 className="email-address">{user.email2}</H6>
                  </div>
                )}
                {user.email3 !== '' && (
                  <div className="email">
                    <Icon name="circle" />
                    <H6 className="email-address">{user.email3}</H6>
                  </div>
                )}
                {user.email4 !== '' && (
                  <div className="email">
                    <Icon name="circle" />
                    <H6>{user.email4}</H6>
                  </div>
                )}
                {user.billing_email1 !== '' && (
                  <div className="email">
                    <Icon name="circle" />
                    <H6 className="email-address">{user.billing_email1}</H6>
                  </div>
                )}
                {user.billing_email2 !== '' && (
                  <div className="email">
                    <Icon name="circle" />
                    <H6 className="email-address">{user.billing_email2}</H6>
                  </div>
                )}
              </div>
            ))}
        </Styles.SearchResult>
        <Styles.Checkboxes>
          {checkbox.map((check, i) => (
            <Styles.Lang key={i} onClick={() => setFieldValue('emailID', check.id)}>
              <RadioButton
                id={check.id}
                checkbox={values.emailID}
                setCheckedValue={(value) => setFieldValue('emailID', value)}
              />
              <H6>{t(`admin/tickets/create.${check.content}`)}</H6>
            </Styles.Lang>
          ))}
        </Styles.Checkboxes>
      </Styles.SearchUsername>
      <FormikErrorMessage formikProp={formikProp} value="emailID" />
    </Styles.CreateTicketStep1SC>
  );
};
export default CreateTicketStep1;
